import { render, staticRenderFns } from "./Quizzes.vue?vue&type=template&id=168ced1c&scoped=true&"
import script from "./Quizzes.vue?vue&type=script&lang=js&"
export * from "./Quizzes.vue?vue&type=script&lang=js&"
import style0 from "./Quizzes.vue?vue&type=style&index=0&id=168ced1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ced1c",
  null
  
)

component.options.__file = "Quizzes.vue"
export default component.exports